const upgradesKeys = {

	// EMPLOYEES
	PRODUCTION_EFFICIENCY: 'prodefficiency',
	DELIVERY_GENIUS: 'deliverygenius',

	// production_employee
	LABOUR_TRAINING:'Labour Training',
	ADVANCED_CRAFTING:'Advanced Crafting Lessons',
	ARTISANS: 'Artisanal Traitmaking Seminars',

	// DELIVERY
	BUILD_ROAD: 'build road',
	STACKABLE_CRATES: 'stackable crates',
	INVENT_CRANES: 'invent cranes',
	HIGH_SPEED_TRAINS: 'HIGH_SPEED_TRAINS',

	// delivery_employee
	HORSES: 'horses',
	WAGONS: 'Wagons & Wheels',
	HUMUNGOUS_WAGONS:'Humungous Wagons',
	TRAINS: 'Invent Trains',


	// builder_employee
	CONSTRUCTION_101: 'Construction 101',
	CONSTRUCTION_INT: 'Intermediate Construction',
	CONSTRUCTION_ADV: 'Advanced Construction Techniques',

	// STORAGE
	BOX_1: 'A Box',
	BOX_2: 'A Second Box',
	BOX_3: 'A Third Box',
	BOX_4: 'A Fourth Box',
	BOX_BIGGER: 'Bigger Boxes',
	BOX_CRATES: 'Crates',
	SHED: 'A Shed',
	STANDARDISED_JARS: 'Standardised Jars',
	VERTICAL_STACKING: 'Vertical Stacking',
	MORE_LAND: 'More land',
	CONTAINERISATION: 'Containerisation',
	AUTOMATED_PIPE_NETWORK: 'AUTOMATED_PIPE_NETWORK',

	// MAKING
	WORKBENCH: 'A Workbench',
	TOOLS: 'Some Tools',
	GLASSBLOWING: 'Actual glassblowing equipment',
	LABELS: 'Label Applicators',
	LABEL_ROLLS: 'Industrial Label Rolls',
	TRAIT_SYNTHESIS: 'Better Trait Synthesis',
	TURBO_PRODUCTION: 'Turbo Production',

	// SPECIAL
	INVENT_MACHINERY: 'INVENT_MACHINERY',
	TALES_OF_THE_PRELIFE: 'TALES_OF_THE_PRELIFE',
	WONDER_ABOUT_LIFE: 'WONDER_ABOUT_LIFE',
	WORK_SATISFACTION: 'WORK_SATISFACTION',
	VISIT_THE_SHOP: 'VISIT_THE_SHOP',
	LEAVE_FOR_EARTH: 'LEAVE_FOR_EARTH',

	// MACHINES
	BETTER_MACHINERY: 'Better Machinery',
	EVEN_BETTER_MACHINERY: 'Even Better Machinery',
	MORE_EFFICIENT_MACHINERY: 'More efficient machinery',
	CHEAPER_MATERIALS: 'Cheaper Materials',
	SMARTER_CONSTRUCTION_METHODS: 'Smarter Construction Methods',
	EVEN_BETTERER_MACHINERY: 'Even Betterer Machinery',
	EVEN_BETTERERER_MACHINERY: 'Even Bettererer Machinery',
	UNIMAGINABLE_MACHINERY: 'Unimaginable Machinery',
	SELF_REPLICATING_MACHINES: 'SELF_REPLICATING_MACHINES',
	FLEXIBLE_MACHINERY: 'FLEXIBLE_MACHINERY'

};

export default upgradesKeys;